import type { LocaleMessageBundle } from '../../types'
import { channelFeatureMessages } from './channel'

export const channelMessages: LocaleMessageBundle = {
  vi: { ...channelFeatureMessages.vi },
  en: { ...channelFeatureMessages.en },
}
